
const digest = 'b6f8463398839fd209adf5a2bb5be51e7f7d6847655114fe3f790f2d353264e3';
const classes = {"wrapper":"_wrapper_739rv_1","thumbnail":"_thumbnail_739rv_7","playButton":"_playButton_739rv_14"};
const css = `._wrapper_739rv_1 {
  width: 100%;
  aspect-ratio: 1.5/1;
  position: relative;
  margin-bottom: 30px;
}
._wrapper_739rv_1 ._thumbnail_739rv_7 {
  height: 100%;
  width: 100%;
  object-fit: cover;
  margin-bottom: 50px;
  border-radius: 15px;
}
._wrapper_739rv_1 ._playButton_739rv_14 {
  position: absolute;
  bottom: -50px;
  left: calc(50% - 75px);
  height: 150px;
  width: 150px;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  